import { useEffect } from 'react';
import { FEATURES, useFeatureIsOn, useGrowthBook } from 'shared/lib/growthbook';
import type { AuthenticatedContractorModel, AuthenticatedManagerModel } from 'entities/profile';

// BAD HOOK!
export const useInjectToGrowthBook = (person: AuthenticatedManagerModel | AuthenticatedContractorModel | undefined) => {
  const growthbook = useGrowthBook();
  const IS_ONBOARDING_ENABLED = useFeatureIsOn(FEATURES.ONBOARDING_ENABLED);

  useEffect(() => {
    if (person && growthbook) {
      const onboardingEnabled = person.featureFlags?.onboardingEnabled ?? IS_ONBOARDING_ENABLED;

      growthbook.setFeatures({
        ...growthbook.getFeatures(),
        onboarding_enabled: {
          defaultValue: onboardingEnabled,
        },
      });
    }
  }, [person, growthbook, IS_ONBOARDING_ENABLED]);
};
